import { COUNTRY_CODES, getDefaultCountryCode } from '../../../utils/countryCodes.js';;

/**
 * Extracts the area code and local number from a full phone number.
 * Falls back to the default country code if none matches.
 */
export function extractPhoneParts(fullPhoneNumber) {
    let phoneAreaCode = getDefaultCountryCode();
    let phoneNumber = '';

    if (fullPhoneNumber) {
        const matchedCode = COUNTRY_CODES.find(option =>
            fullPhoneNumber.startsWith(option.code)
        );

        if (matchedCode) {
            phoneAreaCode = matchedCode.code;
            phoneNumber = fullPhoneNumber.substring(matchedCode.code.length);
        } else {
            phoneNumber = fullPhoneNumber;
        }
    }

    return { phoneAreaCode, phoneNumber };
}

/**
 * Combines the area code and cleaned local number into a full phone number string.
 */
export function buildFullPhoneNumber(areaCode, localNumber) {
    const cleanedPhone = localNumber.replace(/\D/g, '');
    return `${areaCode}${cleanedPhone}`;
}
